/**
 * Module dependencies.
 */

import { NextPage } from 'next/types';
import { NextPageContext } from 'next';
import Metatags from 'src/components/core/metatags';
import NextErrorComponent, { ErrorProps } from 'next/error';
import NotFound from 'src/components/not-found';

/**
 * `ErrorPage` page.
 */

const ErrorPage: NextPage<ErrorProps> = ({ statusCode }) => {
  return (
    <>
      <Metatags pageTitle={statusCode.toString()} />

      {statusCode === 404 ? (
        <NotFound />
      ) : (
        <NextErrorComponent statusCode={statusCode} />
      )}
    </>
  );
};

/**
 * Get initial props.
 */

ErrorPage.getInitialProps = async (ctx: NextPageContext) => {
  const initialProps = await NextErrorComponent.getInitialProps(ctx);

  return { ...initialProps, hasFooter: false };
};

/**
 * Export `ErrorPage` page.
 */

export default ErrorPage;
